import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';

@Component({
  selector: 'app-addtaxgroup',
  templateUrl: './addtaxgroup.component.html',
  styleUrls: ['./addtaxgroup.component.css']
})
export class AddtaxgroupComponent implements OnInit {

//Mode Values
isaddmode:boolean=false;
iseditmode:boolean=false;
isdeletemode:boolean=false;
isviewmode:boolean=false;

//Save Validation
submitted:boolean;
successfully:boolean;


//Edit Get Values
taxgroupColl:any=[];
taxgroupid:number=0

taxgroupform=new FormGroup({
  taxgroupname:new FormControl('',Validators.required),
  taxrate:new FormControl(0),         
  cgsttaxrate: new FormControl(0),         
  sgsttaxrate: new FormControl(0),         
  igsttaxrate:new FormControl(0),         
  taxgroupid:new FormControl(0),      
 inactive:new FormControl(false),     
});

isloading:boolean=false;
isprivilage:boolean=false;  
showProgress:boolean=false;
formname:String="TaxGroup";

istaxtyperead: boolean = true;

constructor(private appService: DhukanDataService,private route: ActivatedRoute,
   public router: Router,private toastr: ToastrService,private loginService:LoginDataService) { 
     this.route.queryParams.subscribe(params => {
      if(params.id!==undefined){
        this.taxgroupid = params.id
      }  

     });
     this.fnServiceChanges();
}


fnServiceChanges(){
  this.loginService.serviceloginChange.subscribe((value) => {
        if(this.loginService.fnCheckUser()){
         
          if(this.fnCheckUserPririvilage()){
            this.isloading=true;
            this.fnOnInitForm();
          }
          else{
            this.fnUserFailedForm();
          }
            
        }
        else{
          this.fnUserFailedForm();
        }
  });
}

ngOnInit() {
    try{
      if(this.loginService.fnCheckUser()){ 
        if(this.fnCheckUserPririvilage()){       
          this.isloading=true;
          this.fnOnInitForm();
        }
        else{
          this.fnUserFailedForm();
        }
      }
      else{
        this.loginService.fnGetUserRoleList();
      }
              
    }catch(ex){
      this.fnShowErrorMsg(ex);
    }
}

fnOnInitForm(){
   try{
       this.isaddmode=true;
       this.taxgroupform.reset();
       this.fnInitializeTaxGroupFormGroup(); 

       if(this.taxgroupid>0){
         this.fngetTaxGroup();
       }
   }catch(ex){
     this.fnShowErrorMsg(ex);
   }
}



fnCheckUserPririvilage(){
  var _check:boolean=false;
  if (this.taxgroupid>0){
    _check= this.loginService.fnCheckUserRoleAction(this.formname,'ALTER')
  }else{
    _check= this.loginService.fnCheckUserRoleAction(this.formname,'CREATE')
  }

  return _check;
}

fnUserFailedForm(){
  this.isprivilage=true;
}


fnInitializeTaxGroupFormGroup(){
   this.taxgroupform.setValue({
      taxgroupname:'',
      taxgroupid:0,      
      taxrate:0,
      cgsttaxrate: null,         
      sgsttaxrate: null,         
      igsttaxrate:null,      
     inactive:false,      
   })
}

//Get 
fngetTaxGroup() {        
     var data = {
       'taxgroupid':this.taxgroupid,            
     }
     this.appService.getTaxGroup(data)
     .subscribe(
       (res)=>{                  
         this.taxgroupColl=res.json().result;
         var editdata = {
           'taxgroupid':this.taxgroupColl[0].taxgrpid,
           'taxgroupname':this.taxgroupColl[0].taxgrpname, 
           'taxrate':this.taxgroupColl[0].taxrate, 
           'cgsttaxrate':this.taxgroupColl[0].cgsttaxrate, 
           'sgsttaxrate':this.taxgroupColl[0].sgsttaxrate, 
           'igsttaxrate':this.taxgroupColl[0].igsttaxrate, 
           'inactive':this.taxgroupColl[0].inactive,          
         }
         this.fnEditMode(editdata);
     },
     (err)=>{          
       this.toastr.error('Error', err);
     })
}

//Save Btn Click
fnSaveBtnClick(){
   try{
     this.submitted=true;
     this.successfully=false;
     //Validate
     if(this.taxgroupform.valid){
         //Check
         var data = {
               'taxgroupid': this.taxgroupid,       
               'taxgroupname':this.taxgroupform.get('taxgroupname').value,            
               'taxrate': this.taxgroupform.get('taxrate').value,
               'cgsttaxrate': this.taxgroupform.get('cgsttaxrate').value,
               'sgsttaxrate': this.taxgroupform.get('sgsttaxrate').value,
               'igsttaxrate':this.taxgroupform.get('igsttaxrate').value,
               'inactive': 0,  
               'createdby': this.loginService.fnGetModUserId(),    
               'modifiedby':this.loginService.fnGetModUserId(), 
         }
         this.appService.fnCheckTaxGroup(data).subscribe(
           (res)=>{
               var _checkresult=res.json().result[0].checkfield;
             
               if(_checkresult==="done"){
                     if (this.taxgroupform.get('taxgroupid').value>0){
                       //Update Department
                       this.fnSetTaxGroup(data);
                     }
                     else{
                       //Insert Department
                       this.fnInsertTaxGroup(data);
                     }
               }
               else{        
                     if(_checkresult==="name"){
                       this.taxgroupform.controls['taxgroupname'].setErrors({'notfound': true});
                     }
               }
         },
         (err)=>{
             this.toastr.error('Error', err);           
         });
      }
   }catch(ex){
     this.fnShowErrorMsg(ex);
   }
}

//Insert
fnInsertTaxGroup(data){    
 
   this.appService.fnInsertTaxGroup(data).subscribe(
     (res)=>{
     if(res.json().result!=""){
       this.toastr.success('', "The new TaxGroup has been added successfully.Insert Successfully");

       this.fnInsertActivityLog('INSERT',0,data.taxgrpname);

       this.fnCloseTaxGroup();
     }},
     (err)=>{
       this.toastr.error('Error', err);
     });

}

//Set
fnSetTaxGroup(data){    

this.appService.fnSetTaxGroup(data).subscribe(
 (res)=>{
 if(res.json().result!=""){
     this.toastr.success('', "The TaxGroup has been updated successfully.");

     this.fnInsertActivityLog('EDIT',this.taxgroupid,data.taxgrpname);

     this.fnCloseTaxGroup();        
 }},
 (err)=>{
   this.toastr.error('Error', err);
 });

}

//Close
fnCloseTaxGroup(){
try{
  this.router.navigate(['/TaxGroup']);
}catch(ex){
   this.fnShowErrorMsg(ex);
}
}

private fnEditMode(deptBO){
 this.taxgroupform.setValue({
    taxgroupname:deptBO.taxgroupname,
    taxgroupid:deptBO.taxgroupid,
    taxrate:deptBO.taxrate,
    cgsttaxrate: deptBO.cgsttaxrate,
    sgsttaxrate: deptBO.sgsttaxrate,
    igsttaxrate: deptBO.igsttaxrate,   
    inactive:deptBO.inactive,   
 });

this.isaddmode=false;
this.iseditmode=true;
this.isdeletemode=false;
this.isviewmode=false;
}

 
fnChangeTaxrate() {


  let taxrate:Number = 0;
  var _cgsttaxrate = this.taxgroupform.get('cgsttaxrate').value
  var _sgsttaxrate = this.taxgroupform.get('sgsttaxrate').value
  var _igsttaxrate = this.taxgroupform.get('igsttaxrate').value
  if (_cgsttaxrate > 0 && _sgsttaxrate > 0) {
    taxrate = Number(_cgsttaxrate) + Number(_sgsttaxrate)

  }
  else {
    taxrate = _igsttaxrate
  }
  this.taxgroupform.patchValue({ taxrate: taxrate })
}

  
  
fnInsertActivityLog(action,refno,desc){
  try{
    var data={
      logtype:action,
      logat:this.formname,
      refnum:refno,
      logdescr:desc,
      logby:this.loginService.fnGetModUserId(),
    }
  

    this.appService.fnInsertActivity(data).subscribe(
      (res)=>{
      },
      (err)=>{
     
      });

  }catch{

  }
}


private fnShowProgress(){
  this.showProgress=true;
}
private fnHideProgress(){
  this.showProgress=false;
}


private  fnShowErrorMsg(ex){
this.toastr.warning('Internal Error', ex);       
}


}
